import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Col, Row, Form, Button, Spinner, Dropdown } from "react-bootstrap";
import OpenBox from "../../../assests/Vector.png";
import "../../../../src/TextFamily.css";
import "../PopUp.css";
import "../DeshBoard.css";
import BankAccountsList from "./BankAccountsList";
import { Api } from "../../../services/httpService";
import { BiPlusCircle } from "react-icons/bi";
import Loader from "../Loader";
import LoaderModal from "../LoaderModal";
import Select from "react-select";
import currencyCodes from "currency-codes";
import ReactCountryFlag from "react-country-flag";
 import Swal from "sweetalert2";

function AddBankDetails({
  setBankOverview,
  bankOverview,
  setAddDetails,
  addDetails,
  companyId,
  merchantId,
  title,
  formData: bankformData,
  setFormData: setBankFormData,
  triggerProgressRefresh,
}) {
  const [show, setShow] = useState(false);

  const initialFormState = {
    accountNum: "",
    ibanNum: "",
    bankName: "",
    branchName: "",
    swiftCode: "",
    currency: "",
    isPrimary: false,
    banksId: ""
  };
  // const sortedCurrencies = [...currencyCodes.data].sort((a, b) => {
  //   if (a.code === "USD") return -1;
  //   if (b.code === "USD") return 1;
  //   return 0;
  // });

  const sortedCurrencies = [...currencyCodes.data].sort((a, b) => {
    if (a.code === "AED") return -1;
    if (b.code === "AED") return 1;

    if (a.code === "USD") return -1;
    if (b.code === "USD") return 1;

    return a.code.localeCompare(b.code); // sort remaining alphabetically
  });

  const currencyOptions = sortedCurrencies.map((currency) => ({
    value: currency.code,
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <ReactCountryFlag
          countryCode={currency.code.slice(0, 2)}
          svg
          style={{ width: "1.5em", marginRight: "10px" }}
        />
        {currency.code} — {currency.currency}
      </div>
    ),
  }));
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [allValid, setAllValid] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bankAccountId, setBankAccountId] = useState(null);
  const id = localStorage.getItem("_id");
  const [bankList, setBankList] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Api(
        "get",
        `/bank/getBanksByCompanyId/${companyId}`,
      );

      if (response && response.body) {
        setAccountList(response.body);
      } else {
        setAccountList([]);
      }
      if (triggerProgressRefresh) triggerProgressRefresh();
      setLoading(false);
    } catch (error) {
      console.error(error);
      setAccountList([]);
    }
  };

  useEffect(() => {
    const fetchBanksList = async () => {
      try {
        const response = await Api("get", `/bank/getBankNamesList`);
        if (response && response.body) {
          // setBankList(response.body?.map((bank) => bank.bankName));
          setBankList(response.body || []);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
    fetchBanksList();
  }, [companyId, bankOverview]);

  const handleClose = () => {
    setTouched({});
    setErrors({});
    setShow(false);
    // if(!bankOverview){
    setFormData(initialFormState);
    // }
  };

  const handleShow = () => setShow(true);


const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  // If checkbox is being checked → show confirmation
  if (type === "checkbox" && checked === true) {
    Swal.fire({
      title: "Are you sure?",
      text: "This will replace the previously selected primary account for this company.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, make primary",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // Update both states only on confirmation
        setFormData((prev) => ({
          ...prev,
          [name]: true,
        }));

        setBankFormData((prev) => ({
          ...prev,
          [name]: true,
        }));

        setTouched((prev) => ({ ...prev, [name]: true }));
      }
    });

    return; // stop normal execution
  }

  // Normal behavior (for unchecking or other fields)
  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));

  setBankFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));

  setTouched((prev) => ({ ...prev, [name]: true }));
};


  useEffect(() => {
    const isValid = validate(formData);
    setAllValid(
      formData.accountNum.trim() &&
        formData.ibanNum.trim() &&
        formData.bankName.trim() &&
        formData.branchName.trim() &&
        formData.swiftCode.trim() &&
        isValid,
    );
  }, [formData]);

  const validate = (data = formData) => {
    const newErrors = {};

    // Bank Account Number: Numeric only; 6-16 digits
    if (!/^\d{6,16}$/.test(data.accountNum)) {
      newErrors.accountNum = "Account number must be 6-16 digits";
    }

    // IBAN: Must be exactly 23 characters, starting with AE followed by 21 digits
    if (!/^AE\d{21}$/.test(data.ibanNum.toUpperCase())) {
      newErrors.ibanNum =
        "IBAN must be exactly 23 characters, start with 'AE' and followed by 21 digits";
    }

    // Bank Name: Cannot be empty
    if (!data.bankName.trim()) {
      newErrors.bankName = "Bank name is required";
    }

    // Branch Name: Min 3 characters, no leading/trailing spaces
    if (!data.branchName.trim()) {
      newErrors.branchName = "Branch name is required";
    } else if (data.branchName !== data.branchName.trim()) {
      newErrors.branchName = "";
    } else if (data.branchName.trim().length < 3) {
      newErrors.branchName = "Branch name must be at least 3 characters";
    }

    // SWIFT Code: 8–11 uppercase alphanumeric, no special chars
    if (!/^[A-Z0-9]{8,11}$/.test(data.swiftCode.toUpperCase())) {
      newErrors.swiftCode =
        "SWIFT code must be 8-11 uppercase letters or numbers";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({
      accountNum: true,
      ibanNum: true,
      bankName: true,
      branchName: true,
      swiftCode: true,
    });
    if (!validate()) return;
    setLoading(true);
    let payload = {
      userId: id,
      accountNum: formData.accountNum,
      ibanNum: formData.ibanNum.toUpperCase(),
      bankName: formData.bankName,
      branchName: formData.branchName.trim(),
      swiftCode: formData.swiftCode.toUpperCase(),
      companyId: companyId,
      bankStatus: formData.bankStatus,
      currency: formData.currency,
      isPrimary: accountList.length > 0 ? formData.isPrimary : true,
      banksId: formData.banksId
    };
    try {
      const response = await Api("post", `/bank/createOrUpdateBank`, payload);

      if (response.success && response.body) {
        await fetchData();
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }
      if (!response.body) {
        setLoading(false);
        alert(response.message);
      }
      handleClose();
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const preventEdgeSpace = (e) => {
    if (e.key === " ") {
      const { selectionStart, value } = e.target;
      // Prevent space at start
      if (selectionStart === 0) {
        e.preventDefault();
      }
      // Prevent double space before or after caret
      if (value[selectionStart - 1] === " " || value[selectionStart] === " ") {
        e.preventDefault();
      }
      // Prevent more than one space at the end
      if (selectionStart === value.length && value.endsWith(" ")) {
        e.preventDefault();
      }
    }
  };
  const preventInvalidSpace = (e) => {
    if (e.key === " ") {
      const { selectionStart, value } = e.target;
      // Prevent space at start or end
      if (selectionStart === 0 || selectionStart === value.length) {
        e.preventDefault();
      }
      // Prevent double space before or after caret
      if (value[selectionStart - 1] === " " || value[selectionStart] === " ") {
        e.preventDefault();
      }
    }
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "12px",
      minHeight: "55px",
      borderColor: state.isFocused ? "#acacc2" : "#f9f9fa",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(196, 196, 202, 0.2)"
        : "none",
      paddingLeft: "35px",
      // Placeholder ko center karne ke liye
      display: "flex",
      alignItems: "center",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#94a3b8",
      // Center alignment ke liye
      margin: 0,
      padding: 0,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "calc(100% - 40px)", // paddingLeft adjust karne ke liye
    }),
    dropdownIndicator: (base) => ({
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0",
      display: "flex",
      alignItems: "center",
      position: "relative",
      height: "100%",
    }),
    singleValue: (base) => ({
      ...base,
      margin: 0,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    }),
  };

  const preventAccNum = (e) => {
    const isDigit = /^\d$/.test(e.key);

    // Block all non-digit keys (allow some special keys like backspace, arrow keys)
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Delete",
    ];

    if (!isDigit && !allowedKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }

    // If it's a digit and input already has 16 digits, prevent further input
    if (isDigit) {
      const { value } = e.target;
      if (value.length >= 16) e.preventDefault();
    }
  };

  const preventIBAN = (e) => {
    if (/^\d$/.test(e.key)) {
      const { value } = e.target;
      if (value.length >= 23) e.preventDefault();
    }
  };
  const preventSwiftCode = (e) => {
    const { value } = e.target;
    // Block input if length is already 11 and user tries to type more
    if (
      value.length >= 11 &&
      e.key.length === 1 &&
      !e.ctrlKey &&
      !e.metaKey &&
      !e.altKey
    ) {
      e.preventDefault();
      return;
    }
    // Prevent space at start or end
    if (e.key === " ") {
      const { selectionStart } = e.target;
      if (selectionStart === 0 || selectionStart === value.length) {
        e.preventDefault();
      }
    }
  };

  if (loading) {
    return (
      <div
        className="company-info-box mt-4 justify-content-center d-flex align-items-center"
        style={{ minHeight: "76vh", position: "relative", zIndex: 5555 }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div className="">
      {/* Header Section */}
      <div className="deshborder-head-title ">
        <div className="container">
          {!bankOverview && (
            <div className="row align-items-end">
              <div className="col-7">
                <h1 className="company-title ">Bank Accounts</h1>
                <p className="com-sub-title">
                  We need these details to add you as a beneficiary for
                  transferring funds to you.
                </p>
              </div>
              <div className="col-5">
                <div className="add-btn-company text-end">
                  {accountList.length > 0 && addDetails && !bankOverview && (
                    <Button
                      className="d-flex align-items-center ms-auto"
                      variant="primary"
                      onClick={handleShow}
                      disabled={accountList.length >= 5}
                    >
                      <span>
                        <BiPlusCircle
                          fill={accountList.length >= 5 ? "black" : "white"}
                        />
                      </span>
                      Add Bank Account
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Empty State */}
      {accountList.length === 0 && addDetails && !bankOverview && (
        <div className="add-company-blog flex-column d-flex align-items-center justify-content-center">
          <div className="add-company-inner mb-3">
            <div className="open-box-icon ">
              <img src={OpenBox} style={{ width: 63 }} />
            </div>
          </div>
          <div className="company-add-status text-center">
            No bank accounts added yet, when you add your
            <br /> bank accounts they will appear here.
          </div>
          <div className="add-btn-company text-end mt-4 pt-2">
            {addDetails && !bankOverview && (
              <Button
                className="d-flex align-items-center ms-auto"
                variant="primary"
                onClick={handleShow}
              >
                Add Bank Details
              </Button>
            )}
          </div>
        </div>
      )}

      {/* Bank Accounts List */}
      {accountList.length > 0 && (
        <BankAccountsList
          accountList={accountList}
          setBankOverview={setBankOverview}
          bankOverview={bankOverview}
          setAddDetails={setAddDetails}
          addDetails={addDetails}
          loading={loading}
          setShow={setShow}
          setBankAccountId={setBankAccountId}
          bankAccountId={bankAccountId}
          merchantId={merchantId}
          companyId={companyId}
          setLoading={setLoading}
          formData={formData}
          setFormData={setFormData}
          fetchData={fetchData}
        />
      )}

      {/*Add Bank Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="company-add-popup"
        centered
      >
        <Modal.Header
          closeButton
          className="d-flex justify-content-between py-3 px-4"
        >
          <Modal.Title>Bank Details</Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSubmit}>
          <Modal.Body className="p-4">
            {loadingModal ? (
              <LoaderModal />
            ) : (
              <Row>
                {/* Account Number */}
                <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Bank Account Number</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Account Number"
                    name="accountNum"
                    value={formData.accountNum || ""}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      preventAccNum(e);
                    }}
                    isInvalid={touched.accountNum && !!errors.accountNum}
                  />
                  {touched.accountNum && errors.accountNum && (
                    <span style={{ color: "red", fontSize: "0.9em" }}>
                      {errors.accountNum}
                    </span>
                  )}
                </Form.Group>

                <div className="row">
                  {/* IBAN Field */}
                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">
                      IBAN Number
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2"
                      placeholder="Enter IBAN"
                      name="ibanNum"
                      value={formData.ibanNum || ""}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        preventInvalidSpace(e);
                        preventIBAN(e);
                      }}
                    />
                    {touched.ibanNum && errors.ibanNum && (
                      <span style={{ color: "red", fontSize: "0.9em" }}>
                        {errors.ibanNum}
                      </span>
                    )}
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">
                      Account Currency
                    </label>

                    <div className="position-relative">
                      {/* Search Icon */}
                      <span
                        style={{
                          position: "absolute",
                          left: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#94a3b8",
                          zIndex: 2,
                        }}
                      >
                        <i class="bi bi-search"></i>{" "}
                      </span>

                      <Select
                        options={currencyOptions}
                        styles={{
                          ...selectStyles,
                          control: (base, state) => ({
                            ...selectStyles.control(base, state),
                            height: "30px",
                          }),
                        }}
                        placeholder="Select Currency"
                        isSearchable
                        onChange={(selected) =>
                          setFormData({
                            ...formData,
                            currency: selected?.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Bank Name */}
                <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Bank Name</Form.Label>
                  <Dropdown
                    onSelect={(eventKey) => {
                      const selectedBank = bankList.find(
                        (bank) => bank.id.toString() === eventKey
                      );

                      setFormData({
                        ...formData,
                        bankName: selectedBank?.bankName || "",
                        banksId: selectedBank?.id || "",
                      });

                      setTouched((prev) => ({
                        ...prev,
                        bankName: true,
                      }));
                    }}
                  >
                    <Dropdown.Toggle
                      variant={
                        formData.bankName
                          ? "secondary"
                          : "outline-secondary"
                      }
                      id="dropdown-bank"
                      className={
                        touched.bankName && errors.bankName
                          ? "is-invalid"
                          : ""
                      }
                    >
                      {formData.bankName
                        ? formData.bankName
                        : "Select Bank Name"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{
                        maxHeight: "150px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      {bankList.map((bank) => (
                        <Dropdown.Item
                          key={bank.id}
                          eventKey={bank.id.toString()}
                        >
                          {bank.bankName}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>

                {/* Branch Name */}
                <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Branch Name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Branch Name"
                    name="branchName"
                    value={formData.branchName || ""}
                    onChange={handleChange}
                    onKeyDown={preventEdgeSpace}
                    isInvalid={touched.branchName && !!errors.branchName}
                  />
                  {touched.branchName && errors.branchName && (
                    <span style={{ color: "red", fontSize: "0.9em" }}>
                      {errors.branchName}
                    </span>
                  )}
                </Form.Group>

                {/* SWIFT Code */}
                <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Swift Code</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter swift code"
                    name="swiftCode"
                    value={formData.swiftCode || ""}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      preventSwiftCode(e);
                    }}
                    isInvalid={touched.swiftCode && !!errors.swiftCode}
                  />
                  {touched.swiftCode && errors.swiftCode && (
                    <span style={{ color: "red", fontSize: "0.9em" }}>
                      {errors.swiftCode}
                    </span>
                  )}
                </Form.Group>
                <div className="col-12 ">
                  {/* Toggle Switch */}
                  <div className="  form-switch d-flex align-items-center mb-2 ">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="primaryAccountSwitch"
                      name="isPrimary"
                      checked={accountList.length > 0 ? formData.isPrimary : true}
                      onChange={handleChange}
                      style={{
                        width: "2.5em",
                        cursor: "pointer",
                      }}
                    />

                    <label
                      htmlFor="primaryAccountSwitch"
                      className="ms-2 mt-1 fs-6" // style={{
                    >
                      Mark this as Primary Account
                    </label>
                  </div>

                  <p
                    className="text-secondary small mb-0"
                    style={{ fontSize: "0.875rem" }}
                  >
                    When toggled on, this account will replace any previously
                    selected primary account for your company.
                  </p>
                </div>
              </Row>
            )}
          </Modal.Body>

          <Modal.Footer className="p-3 border-0 btn-save">
            <Button
              variant={allValid ? "primary active" : "primary"}
              disabled={!allValid}
              className="btn-save"
              type="submit"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default AddBankDetails;
